var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-lg-4 col-12 informational-card mb-4" }, [
    _c(
      "div",
      {
        staticClass:
          "card h-100 justify-content-center align-items-center text-lg-left text-center review-apps clickable",
        on: { click: _vm.handleClick },
      },
      [
        _c(
          "div",
          { staticClass: "row justify-content-between p-3 align-items-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-xl-3 col-lg-4 col-12 d-flex flex-row justify-content-center",
              },
              [
                _c(
                  "h1",
                  {
                    staticClass: "informational-count mb-0",
                    class: _vm.dataCount ? "text-primary" : "text-danger",
                    attrs: { "data-count": _vm.dataCount },
                  },
                  [
                    _vm.isLoading
                      ? [
                          _c("div", {
                            staticClass: "spinner-border text-primary",
                            staticStyle: {
                              height: "4rem",
                              width: "4rem",
                              "border-width": "0.1em",
                            },
                            attrs: { role: "status" },
                          }),
                        ]
                      : [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.dataCount) +
                              "\n          "
                          ),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-xl-9 col-lg-8 col-12 d-flex flex-row justify-content-center",
              },
              [
                _c("h3", {
                  staticClass: "informational-description grey-text mb-0",
                  domProps: { innerHTML: _vm._s(_vm.informationalDescription) },
                }),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }